import axios from 'axios';
import { getCookie, setCookie } from '../utils/cookies';
import URL from '../configs/baseUrl';

function getTokenAuth() {
  if (getCookie('token') !== '' && getCookie('token') !== 'undefined') {
    return JSON.parse(getCookie('token')).value;
  }
  return '';
}

const createAxiosInterceptor = (url) => {
  const axiosCreate = axios.create({
    baseURL: url,
    headers: {
      Accept: 'application/json',
      'Accept-Language': 'es',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getTokenAuth()}`,
    },
  });

  axiosCreate.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      if (error?.response?.status === 401) {
        setCookie('userData', '');
        window.location.replace(URL.LOGIN);
      }
      return Promise.reject(error.response.data);
    }
  );

  return axiosCreate;
};

const BaseService = createAxiosInterceptor(process.env.REACT_APP_REST_URL);

export default BaseService;
